/**
 * When ON (the default), a forecast shared WITH the viewer is promoted to its newest scheduled
 * vintage, on the shared lane's load and by the realtime read-through, exactly as the
 * owner's own forecasts are. When OFF, shared runs keep the vintage their row holds (the
 * owner's last save). Report pointers and the resolved verdict reach shared runs either way;
 * this gates vintages only.
 *
 * The gate is module state rather than React state because its readers are plain commands
 * with no hook to read it through. `useAuthSession` sets it from `/api/me`'s
 * `sharedLiveVintagesEnabled`. It defaults ON until then, matching the server resolver,
 * which fails open.
 */

let live = true;

export function setSharedLiveVintages(value: unknown): void {
  live = value !== false;
}

export function sharedLiveVintages(): boolean {
  return live;
}
